import { Injectable } from '@angular/core';
import { AuthApiService } from '@public/src/api/auth_api.service';
import { AuthMethodApiModel, SmsConfirmCodeApiResult, SmsStartAuthModel } from '@public/src/api/generated/models';
import { sharedResolution } from '@public/src/shared_resolution';
import { from, Observable } from 'rxjs';
import { SpaContext } from '../../../Classes/spacontext';
import { ApiResponse, VisibaApiHttp } from '../../../Classes/visibaHttp.class';

@Injectable()
export class SmsAuthService {
	readonly baseUri = '/Api/Client/v2/units';

	constructor(
		private _http: VisibaApiHttp,
		private _spaContext: SpaContext,
	) {}

	public getAuthMethods(countryCode: string, callTicket: string, unitId: number): Observable<AuthMethodApiModel[]> {
		const authApiService = sharedResolution.resolve(AuthApiService);

		return from(authApiService.getAuthMethods(unitId, countryCode, callTicket).then(({ data }) => data));
	}

	public beginSmsAuth(
		licenceHolderId: number,
		countryCode: string,
		number: string = null,
		callTicket: string = null,
	): Observable<ApiResponse<SmsStartAuthModel>> {
		let uri = `${this.baseUri}/${this._spaContext.unitConfig.Unit.UnitId}/Auth/Methods/Sms/`;
		let query = '?licenceHolderId=' + licenceHolderId + '&countrycode=' + countryCode;

		if (callTicket !== null) {
			uri += 'SendCodeWithCallTicket';
			query += '&callTicket=' + callTicket;
		} else {
			uri += 'SendCode';
		}

		if (number !== null && number !== '') query += '&number=' + encodeURIComponent(number);

		return this._http.postTyped<SmsStartAuthModel>(uri + query, null);
	}

	public resendCode(authAttemptId: Guid): Observable<ApiResponse<void>> {
		const query = '?attemptId=' + authAttemptId;

		return this._http.postTyped<null>(
			`${this.baseUri}/${this._spaContext.unitConfig.Unit.UnitId}/Auth/Methods/Sms/ReSendCode${query}`,
			null,
		);
	}

	public confirmCode(attemptId: string, code: string): Observable<ApiResponse<SmsConfirmCodeApiResult>> {
		const query = '?attemptId=' + attemptId + '&code=' + encodeURIComponent(code);

		return this._http.postTyped<SmsConfirmCodeApiResult>(
			`${this.baseUri}/${this._spaContext.unitConfig.Unit.UnitId}/Auth/Methods/Sms/ConfirmCode${query}`,
			null,
		);
	}
}
